<template>
	<div>
		<breadcrumbs />
		<loading :active.sync="isLoading"></loading>


		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.receipts }}

							</h6>

							<div class="element-box-tp">

								<div class="alert" v-if="status > 200">
									<span v-if="status == 401">
										{{ t.error.access_denied_content }}
									</span>
									<span v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</span>
								</div>
							</div>

							<table-component

									v-if="status == 200 && w >= 700"
									table-class="table table-padded"
									filter-input-class="form-control col-4 float-right rounded bright"
									:data="receipts"
									sort-by="id"
									sort-order="desc"
							>
								<table-column show="id" label="#" cell-class="w50"></table-column>
								<table-column show="currency.iso_code" :label="t.finance.currency" cell-class="w50"></table-column>
								<table-column show="info" :label="t.transaction"  cell-class="w150"></table-column>
								<table-column :label="t.amount" cell-class="w150 text-right">
									<template scope="row">
										{{ row.type.operator }}{{ row.amount | toMoney(row.currency) }}
									</template>
								</table-column>
								<table-column :label="t.user.created_at" cell-class="w150 text-right">
									<template scope="row">
										{{ dateTimeFormat(row.createdAt) }}
									</template>
								</table-column>
								<table-column label="" :sortable="false" :filterable="false" cell-class="w50 p-0 text-center">
									<template scope="row">
										<router-link v-if="row.client" :to="{name: 'userprofile', params: {id: row.client.id}}">
											<span :id="'cu_'+row.id" class="ml-2 pull-right col-12"><i class="os-icon os-icon-user-male-circle2"></i></span>
										</router-link>
										<b-popover :target="'cu_'+row.id" triggers="hover focus" v-if="row.client">
											<div class="user-with-avatar">
												<img alt="" :src="api+'api/v1/users/get/profile_pic/'+row.client.id">
												<span class="d-none d-xl-inline-block">{{ row.client.name }}</span>
											</div>
											<div class="row mt-3">
												<div class="listy b-b" v-if="row.client.online ">
														<span class="label">
															{{ t.betting.title.status }}
														</span>
													{{ t.client.online }}
												</div>
												<div class="listy b-b">
														<span class="label">
															{{ t.user.last_login }}
														</span>
													{{ row.client.lastLogin | timeAgo }}
												</div>
												<div class="listy b-b">
														<span class="label">
															{{ t.user.balance }}
														</span>
													{{ row.client.balance | toMoney(row.client.currency) }}
												</div>
											</div>
										</b-popover>
									</template>
								</table-column>
								<table-column cell-class="w50 row-actions">
									<template scope="row">
									<router-link :to="{name: 'receipt_detail', params: {id: row.id}}">
										<span class="ml-2 pull-right col-12"><i class="os-icon os-icon-ui-37"></i></span>
									</router-link>
									</template>
								</table-column>
							</table-component>

							<paginate v-if="pagination"
							          :page-count="pagination.pageCount"
							          :page-range="pagination.pageRange"
							          :force-page="(pagination.current-1)"
							          :margin-pages="2"
							          :click-handler="onChangePage"
							          :prev-text="t.previous"
							          :next-text="t.next"
							          :container-class="'pagination float-right'"
							          :page-class="'page-item'"
							          :page-link-class="'page-link'"
							          :prev-class="'page-item'"
							          :prev-link-class="'page-link'"
							          :next-class="'page-item'"
							          :next-link-class="'page-link'"
							>
							</paginate>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>

				<div class="element-wrapper pt-4">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">
							<filterGenerator :filter="filter"></filterGenerator>
						</b-collapse>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
    import filterGenerator from '@/components/form/filter'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'receipts',
	    components: { 'table-component': TableComponent, 'table-column': TableColumn, filterGenerator },
        data () {
            return {
                api: window.api,
                w: window.innerWidth,
                t: this.$root.t,
                isLoading: false,
                receipts: null,
                pagination: null,
	            status: 0,
	            filter: null,
                types: null,
                currencies: null
            }
        },
        watch: {
            '$route.query' () {
                this.fetchReceipts();
            }
        },
	    mounted () {
            this.fetchCurrencies();
            this.fetchTypies();
            this.filterReceipts();
            this.fetchReceipts();
	    },
	    methods: {
            fetchReceipts () {
                this.status = 0

                if (!this.isLoading) {

                    this.isLoading = true
                    this.$http.get(api+'api/v1/receipts?noCache=1&_=1', {params: this.filter.model }).then(response => {

                        this.receipts = response.body.result.receipts;
                        this.pagination = response.body.result.pagination;
                        this.isLoading = false
                        this.status = response.status;
                }, response => {
                        this.isLoading = false
                        this.status = response.status;
                    });
                }

	    },
        async fetchTypies () {
	        this.$http.get(api+'api/v1/receipt/type?noCache=1')
	            .then(response => {

	            this.types = response.body.result;
	            this.filterReceipts()
		    }, response => {

		        })
	    },
	    async fetchCurrencies () {
	        this.$http.get(api+'api/v1/currencies')
	            .then(response => {

	            this.currencies = response.body.result.currencies;
	        this.filterReceipts();
	    }, response => {

	        })
	    },
		filterReceipts () {
		    this.filter = {
		        model: {
		            page: 1,
		            uid: '',
		            username: '',
		            currencies: [],
		            types: [],
		            rangeDateTime: '',
		            rangeAmount: {}
		        },
		        schema: {
		            groups: [
		                {
		                    legend: 'Genel',
		                    fields: [
		                        {
		                            type: "input",
		                            inputType: "number",
		                            label: this.t.user.id,
		                            model: "uid",
		                            readonly: false,
		                            featured: false,
		                            disabled: false
		                        },
		                        {
		                            type: "User",
		                            label: this.t.user.username,
		                            model: "uid",
		                            readonly: false,
		                            featured: false,
		                            disabled: false
		                        },
		                        {
		                            type: "AmountRange",
		                            label: this.t.amount_range,
		                            model: "rangeAmount",
		                            readonly: false,
		                            featured: false,
		                            disabled: false
		                        },
		                        {
		                            type: "Datepicker",
		                            class: 'test',
		                            label: this.t.created_at,
		                            model: "rangeDateTime",
		                            readonly: false,
		                            featured: false,
		                            disabled: false,
		                            options: {
		                                not_before: null,
		                                clearable: true,
		                                range: true,
		                                firstDay: 1,
		                                format: 'YYYY-MM-DD',
		                                dataFormat: 'YYYY-MM-DD',
		                            }
		                        },
		                        {
		                            type: "checklist",
		                            label: this.t.transaction,
		                            model: "types",
		                            multi: true,
		                            required: false,
		                            multiSelect: true,
		                            values: this.types,
		                            checklistOptions: {
		                                value: "id",
		                                name: "info"
		                            }
		                        },
		                        {
		                            type: "checklist",
		                            label: this.t.finance.currency,
		                            model: "currencies",
		                            multi: true,
		                            required: false,
		                            multiSelect: true,
		                            values: this.currencies,
		                            checklistOptions: {
		                                value: "id",
		                                name: "iso_code"
		                            }
		                        },
		                        {
		                            type: "submit",
		                            label: "",
		                            buttonText: this.t.filter.title,
		                            onSubmit: this.fetchReceipts,
		                            validateBeforeSubmit: false,
		                        }
		                    ]
		                },
		            ],
		        },
		        options: {
		            validateAfterLoad: true,
		            validateAfterChanged: true
		        }
		    }
		},
	    onChangePage (page) {
	        this.pagination.current = page;

	        this.$route.query.page = page;
	        var qr = this.$route.query;
	        this.$router.push({});

	        this.$router.push({ query: qr });

	        this.filter.model.page = page;

	        window.scroll(0, 0);
	    },
	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/receipt/list.vue